  $(document).ready(function () {
    var $menuTriggers = $('details.mega-menu');
    var $megaMenuContents = $('.mega-menu__content');
    var $siteOverlay = $('#site-overlay');

    // Function to show the mega menu with fade-in effect
    function showMegaMenu($menuContent) {
      $menuContent.stop(true, true).fadeIn(50).addClass('open');
      $siteOverlay.stop(true, true).fadeIn(500).addClass('open');
    }

    // Function to hide the mega menu with fade-out effect
    function hideMegaMenu($menuContent) {
      $menuContent.stop(true, true).fadeOut(50).removeClass('open');
      if (!$('.mega-menu__content.open').length) {
        $siteOverlay.stop(true, true).fadeOut(500).removeClass('open');
      }
    }

    // Add click event listener to each menu trigger
    $menuTriggers.on('click', function (event) {
      // Ignore right-click
      event.stopPropagation(); // Prevent event from bubbling up
      var $currentMenuContent = $(this).find('.mega-menu__content');

      // Hide all other menus
      $megaMenuContents.not($currentMenuContent).each(function () {
        hideMegaMenu($(this));
      });

      // Toggle the current menu
      if ($currentMenuContent.is(':visible')) {
        hideMegaMenu($currentMenuContent);
      } else {
        showMegaMenu($currentMenuContent);
      }
    });

    // Hide the mega menu and overlay when clicking outside of it
    $(document).on('click', function (event) {
      $menuTriggers.each(function () {
        var $currentTrigger = $(this);
        var $currentMenuContent = $currentTrigger.find('.mega-menu__content');

        if (
          $currentMenuContent.is(':visible') &&
          !$currentTrigger.is(event.target) &&
          !$currentTrigger.has(event.target).length &&
          !$currentMenuContent.is(event.target) &&
          !$currentMenuContent.has(event.target).length
        ) {
          hideMegaMenu($currentMenuContent);
        }
      });
    });

    // Optional: Hide the mega menu and overlay when clicking on an item inside it
    $megaMenuContents.on('click', 'a', function () {
      hideMegaMenu($(this).closest('.mega-menu__content'));
    });

    // Hide the mega menu and overlay when clicking on the overlay itself
    $siteOverlay.on('click', function () {
      $megaMenuContents.each(function () {
        hideMegaMenu($(this));
      });
    });
  });

    $(document).ready(function () {
    $('.accordion-button').on('click', function () {
      $(this).toggleClass('active').siblings('.accordion-content').toggleClass('active');
    });
  });

    $(document).ready(function () {
    // Add click event listener to the overlay
    $('#videoOverlay').click(function () {
      // Play the video
      var videoElement = $('.video-container-homepage video').get(0);
      if (videoElement.paused) {
        videoElement.play();
      }
      // Hide the overlay
      $(this).css('display', 'none');
    });
  });

  $(document).ready(function () {
    var $videoModal = $('#videoModal');
    var $videoBtnDesktop = $('.video-btn.desktop');
    var $videoBtnMobile = $('.video-btn.mobile');
    var $videoModalClose = $('.video-modal-close');
    var $videoDesktop = $('.video-modal-content .desktop-video video');
    var $videoMobile = $('.video-modal-content .mobile-video video');

    $videoBtnDesktop.on('click', function (e) {
      e.preventDefault();
      $videoModal.show();
      $videoDesktop.trigger('play');
      $videoModal.addClass('opened');
    });

    $videoBtnMobile.on('click', function (e) {
      e.preventDefault();
      $videoModal.show();
      $videoMobile.trigger('play');
      $videoModal.addClass('opened');
    });

    $videoModalClose.on('click', function () {
      $videoModal.hide();
      $videoDesktop.trigger('pause');
      $videoMobile.trigger('pause');
      $videoModal.removeClass('opened');
    });

    $(window).on('click', function (event) {
      if ($(event.target).is($videoModal)) {
        $videoModal.hide();
        $videoDesktop.trigger('pause');
        $videoMobile.trigger('pause');
        $videoModal.removeClass('opened');
      }
    });
    
  });

   $('.products-carousel').slick({
    slidesToShow: 4,
    infinite: false,
    arrows: true,
    adaptiveHeight: true,
    prevArrow:
      '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg></button>',
    nextArrow:
      '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          arrows: false,
          adaptiveHeight: false,
          dots: true,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2.5,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 1550,
        settings: {
          slidesToShow: 3.5,
          arrows: false,
          dots: true,
        },
      }
    ],
  });

  $('.products-carousel').find('.slick-prev').hide();

  $('.products-carousel').on('afterChange', function (event, slick, currentSlide) {
    var prevArrow = $(this).find('.slick-prev');
    var nextArrow = $(this).find('.slick-next');
    var slidesToShow = slick.options.slidesToShow;
    var totalSlides = slick.slideCount;
    var slidesRemaining = totalSlides - (currentSlide + slidesToShow);

    if (currentSlide === 0) {
      prevArrow.hide();
    } else {
      prevArrow.show();
    }

    if (slidesRemaining <= 0) {
      nextArrow.hide();
    } else {
      nextArrow.show();
    }
  });

  var sections = $('.product-box'),
    nav = $('.nav'),
    nav_height = nav.outerHeight();

  $(window).on('scroll', function () {
    var cur_pos = $(this).scrollTop() + 230;
    sections.each(function () {
      var top = $(this).offset().top - nav_height,
        bottom = top + $(this).outerHeight();
      if (cur_pos >= top && cur_pos <= bottom) {
        nav.find('.nav-link').removeClass('active');
        sections.removeClass('active');
        $(this).addClass('active');
        nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
      }
    });
  });

  $(document).ready(function () {
    $('.nav-link').click(function () {
      // Remove active class from all nav-items
      $('.nav-link').removeClass('active');

      // Add active class to the clicked item
      $(this).addClass('active');
    });
  });

  $(document).ready(function () {
    var element = $('.products-nav');
    var initialTop = element.offset().top;

    $(window).scroll(function () {
      var scrollPosition = $(window).scrollTop();

      if (scrollPosition >= initialTop) {
        element.css({
          position: 'sticky',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: '1',
        });
      } else {
        element.css({
          position: 'static',
          boxShadow: 'none',
        });
      }
    });
  });

  jQuery('.page-link').click(function (e) {
    e.preventDefault();
    var menu_height = jQuery('header').outerHeight();
    var href = $(this).attr('href');
    setTimeout(function () {
      $('html,body').animate({ scrollTop: $(href).offset().top - menu_height });
    }, 500);
  });

//  document.addEventListener("DOMContentLoaded", function () {
//   // Get the slide data elements

//   // Elements to update
//   const heroSection = document.querySelector(".full-bleed-hero-outer");
//   const heroTitle = heroSection.querySelector(".hero-title");
//   const heroDesc = heroSection.querySelector(".heading__wysiwyg p");
//   const heroButton = heroSection.querySelector(".hero-button");
//   const heroContainer = heroSection.querySelector(".full-bleed-hero");

//   let currentSlideIndex = 0;
//   let carouselInterval;
//   let isPlaying = true;
//   let animationStartTime = null;
//   let loadingAnimation;

//   // Function to update slide with fade effect
//   function updateSlide(index) {
//     // Start fade out
//     heroContainer.style.opacity = "0";

//     // After fade out completes, update content and fade in
//     setTimeout(() => {
//       // Update content
//       heroTitle.innerHTML = slides[index].title;
//       heroDesc.innerHTML = slides[index].desc;

//       // Update button if it exists
//       if (heroButton) {
//         heroButton.innerHTML = slides[index].btnName;
//         heroButton.setAttribute("href", slides[index].btnUrl);

//         // Show or hide button based on whether button name exists
//         if (slides[index].btnName && slides[index].btnName.trim() !== "") {
//           heroButton.style.display = "";
//         } else {
//           heroButton.style.display = "none";
//         }
//       }

//       // Update background
//       heroContainer.style.setProperty("--bg", slides[index].bgImage);

//       // Update indicator dots
//       updateIndicators(index);

//       // Start fade in
//       heroContainer.style.opacity = "1";

//       // Reset loading animation
//       resetLoadingAnimation();
//     }, 500); // 500ms for fade out
//   }

//   // Function to cycle through slides
//   function cycleSlides() {
//     currentSlideIndex = (currentSlideIndex + 1) % slides.length;
//     updateSlide(currentSlideIndex);
//   }

//   // Function to start carousel
//   function startCarousel() {
//     if (!isPlaying) {
//       isPlaying = true;
//       carouselInterval = setInterval(cycleSlides, 7000);
//       updatePlayPauseButton();
//       startLoadingAnimation();
//     }
//   }

//   // Function to stop carousel
//   function stopCarousel() {
//     if (isPlaying) {
//       isPlaying = false;
//       clearInterval(carouselInterval);
//       updatePlayPauseButton();
//       stopLoadingAnimation();
//     }
//   }

//   // Function to toggle play/pause
//   function togglePlayPause() {
//     if (isPlaying) {
//       stopCarousel();
//     } else {
//       startCarousel();
//     }
//   }

//   // Function to go to a specific slide
//   function goToSlide(index) {
//     if (index === currentSlideIndex) return;

//     currentSlideIndex = index;
//     updateSlide(currentSlideIndex);

//     // Reset the timer if carousel is playing
//     if (isPlaying) {
//       clearInterval(carouselInterval);
//       carouselInterval = setInterval(cycleSlides, 7000);
//       resetLoadingAnimation();
//     }
//   }

//   // Function to update play/pause button appearance
//   function updatePlayPauseButton() {
//     const playPauseBtn = document.querySelector(".carousel-play-pause-btn");
//     if (playPauseBtn) {
//       if (isPlaying) {
//         playPauseBtn.innerHTML = `
//           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <rect x="3" y="2" width="3" height="12" rx="1" fill="currentColor"/>
//             <rect x="10" y="2" width="3" height="12" rx="1" fill="currentColor"/>
//           </svg>
//         `;
//         playPauseBtn.setAttribute("aria-label", "Pause carousel");
//       } else {
//         playPauseBtn.innerHTML = `
//           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//             <path d="M4 2.5L13 8L4 13.5V2.5Z" fill="currentColor"/>
//           </svg>
//         `;
//         playPauseBtn.setAttribute("aria-label", "Play carousel");
//       }
//     }
//   }

//   // Function to update indicator dots
//   function updateIndicators(activeIndex) {
//     const indicators = document.querySelectorAll(".carousel-indicator");
//     indicators.forEach((indicator, index) => {
//       if (index === activeIndex) {
//         indicator.classList.add("active");
//       } else {
//         indicator.classList.remove("active");
//       }
//     });
//   }

//   // Function to animate the loading progress
//   function animateLoading(timestamp) {
//     if (!isPlaying) return;

//     if (!animationStartTime) animationStartTime = timestamp;
//     const progress = Math.min((timestamp - animationStartTime) / 7000, 1);

//     // Update the loading circle
//     const circle = document.querySelector(".loading-progress-circle");
//     if (circle) {
//       const circumference = 2 * Math.PI * 18; // 18 is the radius of our circle
//       const dashOffset = circumference * (1 - progress);
//       circle.style.strokeDashoffset = dashOffset;
//     }

//     if (progress < 1) {
//       loadingAnimation = requestAnimationFrame(animateLoading);
//     }
//   }

//   // Function to start the loading animation
//   function startLoadingAnimation() {
//     animationStartTime = null;
//     if (isPlaying) {
//       loadingAnimation = requestAnimationFrame(animateLoading);
//     }
//   }

//   // Function to stop the loading animation
//   function stopLoadingAnimation() {
//     if (loadingAnimation) {
//       cancelAnimationFrame(loadingAnimation);
//       loadingAnimation = null;
//     }
//   }

//   // Function to reset the loading animation
//   function resetLoadingAnimation() {
//     stopLoadingAnimation();

//     // Reset the circle progress
//     const circle = document.querySelector(".loading-progress-circle");
//     if (circle) {
//       const circumference = 2 * Math.PI * 18;
//       circle.style.strokeDashoffset = circumference;
//     }

//     // Start the animation again if playing
//     if (isPlaying) {
//       startLoadingAnimation();
//     }
//   }

//   // Create and add carousel controls
//   function createCarouselControls() {
//     const controlsContainer = document.createElement("div");
//     controlsContainer.className = "carousel-controls";

//     // Create indicators
//     const indicatorsContainer = document.createElement("div");
//     indicatorsContainer.className = "carousel-indicators";

//     for (let i = 0; i < slides.length; i++) {
//       const indicator = document.createElement("button");
//       indicator.className = "carousel-indicator";
//       if (i === 0) indicator.classList.add("active");
//       indicator.setAttribute("aria-label", `Go to slide ${i + 1}`);
//       indicator.addEventListener("click", () => goToSlide(i));
//       indicatorsContainer.appendChild(indicator);
//     }

//     // Create play/pause button container with loading indicator
//     const playPauseContainer = document.createElement("div");
//     playPauseContainer.className = "carousel-play-pause-container";

//     // Create SVG for loading indicator
//     const svgNS = "http://www.w3.org/2000/svg";
//     const svg = document.createElementNS(svgNS, "svg");
//     svg.setAttribute("width", "40");
//     svg.setAttribute("height", "40");
//     svg.classList.add("loading-progress");

//     // Background circle
//     const bgCircle = document.createElementNS(svgNS, "circle");
//     bgCircle.setAttribute("cx", "20");
//     bgCircle.setAttribute("cy", "20");
//     bgCircle.setAttribute("r", "18");
//     bgCircle.setAttribute("fill", "none");
//     bgCircle.setAttribute("stroke", "rgba(255, 255, 255, 0.3)");
//     bgCircle.setAttribute("stroke-width", "2");

//     // Progress circle
//     const progressCircle = document.createElementNS(svgNS, "circle");
//     progressCircle.setAttribute("cx", "20");
//     progressCircle.setAttribute("cy", "20");
//     progressCircle.setAttribute("r", "18");
//     progressCircle.setAttribute("fill", "none");
//     progressCircle.setAttribute("stroke", "white");
//     progressCircle.setAttribute("stroke-width", "2");
//     progressCircle.setAttribute("stroke-linecap", "round");
//     progressCircle.classList.add("loading-progress-circle");

//     // Calculate the circumference
//     const circumference = 2 * Math.PI * 18;
//     progressCircle.style.strokeDasharray = circumference;
//     progressCircle.style.strokeDashoffset = circumference;
//     progressCircle.style.transform = "rotate(-90deg)";
//     progressCircle.style.transformOrigin = "center";

//     svg.appendChild(bgCircle);
//     svg.appendChild(progressCircle);

//     // Create play/pause button
//     const playPauseBtn = document.createElement("button");
//     playPauseBtn.className = "carousel-play-pause-btn";
//     playPauseBtn.addEventListener("click", togglePlayPause);
//     playPauseBtn.innerHTML = `
//       <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <rect x="3" y="2" width="3" height="12" rx="1" fill="currentColor"/>
//         <rect x="10" y="2" width="3" height="12" rx="1" fill="currentColor"/>
//       </svg>
//     `;
//     playPauseBtn.setAttribute("aria-label", "Pause carousel");

//     // Add SVG and button to container
//     playPauseContainer.appendChild(svg);
//     playPauseContainer.appendChild(playPauseBtn);

//     // Add all controls to container
//     controlsContainer.appendChild(indicatorsContainer);
//     controlsContainer.appendChild(playPauseContainer);

//     // Add controls to hero section
//     heroSection.appendChild(controlsContainer);
//   }

//   // Create controls
//   createCarouselControls();

//   // Start the carousel
//   carouselInterval = setInterval(cycleSlides, 7000);

//   // Start the loading animation
//   startLoadingAnimation();
// });